var tabs = document.querySelectorAll('ul.tabs');
tabs.forEach(function(tabGroup) {
  var tab = tabGroup.querySelectorAll('li > a');
  tab.forEach(function(tabItem) {
    tabItem.addEventListener('click', function(e) {
      var contentLocation = this.getAttribute('href');
      if (contentLocation.charAt(0) == '#') {
        e.preventDefault();
        tab.forEach(function(item) {
          item.classList.remove('active');
        });
        this.classList.add('active');
        var tabContent = this.closest('ul.tabs').nextElementSibling;
        var contentToShow = tabContent.querySelector(contentLocation);
        contentToShow.style.display = 'block';
        contentToShow.classList.add('active');
        var siblings = contentToShow.parentNode.children;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== contentToShow) {
            siblings[i].style.display = 'none';
            siblings[i].classList.remove('active');
          }
        }
      }
    });
  });
});
